import { Link } from 'react-router-dom';
import { mainSiteUrl, categories } from '@/mocks/categories';

export default function Hero() {
  const handleCategoryChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const url = e.target.value;
    if (url) {
      window.open(url, '_blank', 'noopener,noreferrer');
      e.target.value = '';
    }
  };

  return (
    <section className="relative min-h-screen flex items-center pt-16 overflow-hidden">
      <div className="absolute inset-0 z-0">
        <img
          src="https://readdy.ai/api/search-image?query=Modern%20bright%20workspace%20with%20large%20monitor%20displaying%20colorful%20spreadsheet%20charts%20and%20product%20thumbnails%2C%20surrounded%20by%20tastefully%20arranged%20fashion%20items%20on%20a%20clean%20white%20desk%2C%20green%20potted%20plant%2C%20natural%20sunlight%20pouring%20through%20large%20windows%2C%20professional%20yet%20inviting%20atmosphere%2C%20high%20detail%20editorial%20photography%2C%20bright%20airy%20aesthetic&width=1600&height=900&seq=hero-main-2026-v2&orientation=landscape"
          alt="BaseTao Spreadsheet resource hub"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-white/50 via-white/30 to-white/95"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 py-12 md:py-20">
        <div className="max-w-4xl mx-auto text-center">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-accent-100 text-accent-800 text-xs font-semibold mb-6">
            <i className="ri-sparkling-line"></i>
            <span>Trusted Research Resource</span>
          </div>

          <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-gray-900 leading-tight mb-6 drop-shadow-sm">
            BaseTao Spreadsheet — The Complete Research Database, Review Guide &amp; Shopping Resource
          </h1>

          <p className="text-base md:text-lg text-gray-700 max-w-2xl mx-auto mb-10 leading-relaxed">
            Discover BaseTao Spreadsheet guides, product research tools, shipping cost analysis, warehouse tips, discount opportunities, and expert comparisons before making better purchasing decisions.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-10">
            <Link
              to="/article/basetao-spreadsheet-guide"
              className="w-full sm:w-auto px-8 py-3.5 bg-primary-500 text-white font-semibold text-sm rounded-full hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer shadow-sm"
            >
              Explore BaseTao Spreadsheet Guide
            </Link>
            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="w-full sm:w-auto px-8 py-3.5 border-2 border-gray-400 text-gray-800 font-semibold text-sm rounded-full hover:border-gray-600 hover:text-gray-950 transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              Visit Main Website
            </a>
          </div>

          <div className="max-w-md mx-auto mb-12">
            <label htmlFor="category-select" className="block text-sm font-semibold text-gray-800 mb-2 text-left">
              Browse Product Categories
            </label>
            <div className="relative">
              <select
                id="category-select"
                onChange={handleCategoryChange}
                defaultValue=""
                className="w-full appearance-none bg-white border border-gray-300 rounded-xl px-5 py-3.5 pr-12 text-sm text-gray-800 focus:outline-none focus:ring-2 focus:ring-primary-400 focus:border-primary-400 transition-all cursor-pointer shadow-sm"
              >
                <option value="" disabled>Select a category to explore...</option>
                {categories.map((cat) => (
                  <option key={cat.name} value={cat.url}>
                    {cat.name} — {cat.description}
                  </option>
                ))}
              </select>
              <div className="absolute right-4 top-1/2 -translate-y-1/2 w-4 h-4 flex items-center justify-center pointer-events-none">
                <i className="ri-arrow-down-s-line text-gray-500 text-lg"></i>
              </div>
            </div>
          </div>

          <div className="flex flex-wrap items-center justify-center gap-3">
            {['BaseTao Spreadsheet Research', 'Shipping Cost Analysis', 'Warehouse Guide', 'Verified Reviews', 'Discount Tracking'].map((badge) => (
              <span key={badge} className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-white/90 rounded-full text-xs font-medium text-gray-700 border border-gray-200 shadow-sm">
                <i className="ri-check-line text-accent-500 text-sm"></i>
                {badge}
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}